






import { Component, Vue } from "vue-property-decorator";
import AuditLimbahList from "@/components/ppi/audit-limbah/AuditLimbahList.vue";

@Component({
  components: { AuditLimbahList }
})
export default class AuditLimbahPage extends Vue {}
